import React from 'react';

export const Facebook: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" style={props.style}>
    <path d="M255.6,16.43H44.4c-21.13,0-28.8,17.23-28.8,28.8v211.2c0,21.13,17.22,28.8,28.8,28.8H102V266H44.51c-4.43-.11-9.71-1.87-9.71-9.6V45.35c.11-4.43,1.87-9.72,9.6-9.72H255.49c4.43.11,9.71,1.87,9.71,9.6V256.32c-.11,4.43-1.87,9.71-9.6,9.71H150V170h28.8v-19.2H150v-48a26.89,26.89,0,0,1,2.59-10.1c3.1-6.21,8.38-9.1,16.61-9.1,8,0,13.25,2.75,16.38,8.65a26.41,26.41,0,0,1,2.82,10.55h19.2c0-15.43-10.23-38.4-38.4-38.4s-38.4,23-38.4,38.4v48H102V170h28.8v115.2H255.6c21.13,0,28.8-17.22,28.8-28.8V45.23C284.4,24.1,267.18,16.43,255.6,16.43Z"/>
  </svg>
);
